module.exports = __webpack_public_path__ + "static/media/new_appointment_white.805d83d2.svg";